module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_iter-step.js
// module id = 187
// module chunks = 2 3 4 5 6 7 8 9 10 11 12